export interface PollOptionWithVotes {
  id: string;
  votes: number;
}

export interface PollMajorityResult {
  winner: PollOptionWithVotes | null;
  isTie: boolean;
  tiedOptions: PollOptionWithVotes[];
}

/** Simple majority: highest vote count wins; ties return isTie=true. */
export function getPollWinningOption(options: PollOptionWithVotes[]): PollMajorityResult {
  if (options.length === 0) {
    return { winner: null, isTie: false, tiedOptions: [] };
  }

  const maxVotes = Math.max(...options.map((o) => o.votes));
  if (maxVotes === 0) {
    return { winner: null, isTie: false, tiedOptions: [] };
  }

  const topOptions = options.filter((o) => o.votes === maxVotes);
  if (topOptions.length > 1) {
    return { winner: null, isTie: true, tiedOptions: topOptions };
  }

  return { winner: topOptions[0], isTie: false, tiedOptions: [] };
}
